module.exports = __webpack_public_path__ + "img/step17_a_remove_endcaps.c44603cc.png";